export default __webpack_public_path__ + "static/media/1378700110244-1-point-5-768x509.779fe356.jpg";